var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBgBlur = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 664,
    viewBox: "0 0 732 664",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_48_3811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.6,
    y: -78,
    width: 687,
    height: 610,
    fill: "url(#paint0_linear_48_3811)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_48_3811",
    x: 0.0000915527,
    y: -209.6,
    width: 950.2,
    height: 873.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.8,
    result: "effect1_foregroundBlur_48_3811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_3811",
    x1: 818.6,
    y1: -78,
    x2: 132.263,
    y2: 532.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC0C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14151A",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBgBlur);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg_blur.d374733465bbb0ac706153af2f740e5a.svg";